import TiktokEmbedPost from '@cohort/components-xps/components/apps/tiktok/TiktokEmbedPost';
import type {TikTokLikeTiktokTriggerStruct} from '@cohort/shared/apps/tiktok/triggers/likeTiktok';
import serializeDataAttributes from '@cohort/shared-frontend/utils/serializeDataAtttributes';
import type {DetailsComponentProps} from '@cohort/wallet/apps/TriggerIntegration';

const TiktokLikeTiktokTriggerIntegrationDetailsComponent: React.FC<
  DetailsComponentProps<TikTokLikeTiktokTriggerStruct>
> = ({config, stepId, triggerId}) => (
  <div
    className="flex w-full items-center justify-center"
    {...serializeDataAttributes({
      'step-id': stepId,
      'trigger-id': triggerId,
    })}
  >
    <TiktokEmbedPost videoId={config.videoId} />
  </div>
);

export default TiktokLikeTiktokTriggerIntegrationDetailsComponent;
